import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import Swal from 'sweetalert2';

import Button from 'Flow2/components/UI/Button/Button';
import ButtonStyle from 'Flow2/components/UI/Button/Button.module.scss';

import FlexRow from 'Flow2/components/UI/Container/FlexRow';
import FlexColumn from 'Flow2/components/UI/Container/FlexColumn';
import TagsTree from 'Flow2/components/TagsTree/TagsTree';

import Checkbox from 'Flow2/components/UI/Checkbox/Checkbox';
import Input from 'Flow2/components/UI/Input/Input';

import classes from './Masterdata.module.scss';
import * as actions from 'store/actions/index';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as metadata from 'Flow2/containers/Masterdata/Masterdata';
import StructureMapping from 'Flow2/util/StructureMapping.js';
import MetadataLanguage from 'Flow2/util/MetadataLanguage.js';
import MetadataElementHelper from 'Flow2/util/MetadataElementHelper.js';
import MetadataPermissionHelper from 'Flow2/util/MetadataPermissionHelper.js';

import { IntlProvider, FormattedMessage, injectIntl, addLocaleData } from 'react-intl';
import locale_en from 'react-intl/locale-data/en';
import locale_de from 'react-intl/locale-data/de';
import deTranslation from "PMDB/assets/languages/de.json";
import enTranslation from "PMDB/assets/languages/en.json";

import { de } from 'date-fns/locale/de';
import { format, isValid } from 'date-fns';
import Spinner from 'Flow2/components/UI/Spinner/Spinner';
import { isPMDB, isTranscoder1, isVifogra, isPorscheArchiv } from "Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil";
import LogsHelper from 'Flow2/components/Article/Helpers/LogsHelper';
import HelpWindow from 'Flow2/components/UI/Overlay/HelpWindow';
import { Tooltip } from 'Flow2/pages/Clip/ClipDetails';
//registerLocale('de', de);

import RoomSetting from "Flow2/components/Metadata/RoomSetting";

import { ProjectOverview } from "Flow2/components/Metadata/ProjectOverview";


import * as Panel from 'Flow2/containers/Panel/Panel';

export const OBJECT_TYPE_CLIP = 'clip';
export const OBJECT_TYPE_ROOM = 'room';
export const OBJECT_TYPE_PROJECT = 'project';
export const OBJECT_TYPE_UPLOADPROJECT = 'uploadproject';
export const OBJECT_TYPE_EVENTROOM = 'eventroom';
export const OBJECT_TYPE_DISTRIBUTION = 'distribution';
export const OBJECT_TYPE_MEDIAFILE = 'mediafile';
export const OBJECT_TYPE_NEWSROOM = 'newsroom';
export const OBJECT_TYPE_SERIES = 'series';
export const OBJECT_TYPE_ARTICLE = 'article';
export const OBJECT_TYPE_LANE = 'lane';
export const OBJECT_TYPE_TVLANE = 'tvlane';
export const OBJECT_TYPE_PM = 'pm';
export const OBJECT_TYPE_WPS = 'wps';
export const OBJECT_TYPE_RENT = 'rent';

export const METADATA_MODE_TEXT = 'text';
export const METADATA_MODE_EDIT = 'edit';
export const METADATA_MODE_EDIT_ALWAYS = "METADATA_MODE_EDIT_ALWAYS";
const METADATA_MODE_CANCEL = 'cancel';

export const METADATA_ALWAYS_UPDATE = "METADATA_ALWAYS_UPDATE";
export const METADATA_NO_UPDATE = "METADATA_NO_UPDATE";
export const METADATA_UPDATE_DIALOG = "METADATA_UPDATE_DIALOG";

export const METADATA_CONTENT_METADATA = "METADATA_CONTENT_METADATA";
export const METADATA_CONTENT_SETTING = "METADATA_CONTENT_SETTING";
export const METADATA_CONTENT_CLIPS = "METADATA_CONTENT_CLIPS";


export const ArchivenumberPrefix = (props) => {
    if(props.mode !== "edit" || !props.changedElements.content)  return "";
    
    const prefix = {
        historischesbildarchiv: [ "", "HAV", "HDG", "HDK", "HDM", "HDI", "HNE" ],
        bertelsmann: [ "", "BK" ],
        betriebsanleitung: [ "", "BA", "TMT" ],
        garantiewartung: [ "", "GW" ],
        print: [ "", "KAL", "P", "W", "WH" ],
        dokumentation: [ "", "Dok" ],
        medienresonanz: [ "", "Med" ],
        presseinformation: [ "", "Pr" ],
        cdrom: [ "", "DVD", "[reine Nummer]" ],
        findbucher: [ "", "FBE" ],
        kleinexponat: [ "", "B", "NA", "NB", "NF", "NM", "NW", "T", "WA" ]
    };

    const options = prefix[props.changedElements.content].map(pf => {
        if(!pf) {
            return { value: "", displayValue: "Bitte wählen" }
        }
        return { value: pf, displayValue: pf }
    });
    
    return (
            <tr key={"archivenumberprefix"}>
            <th className={[classes.Mandatory, (props.mode === 'edit' ? StructureMapping.isMandatoryEdit(props.element.obj) : "")].join(' ')}>
                <FormattedMessage id={props.element.intl} defaultMessage={props.element.name} />
            </th>
            <td className={[classes.Fail, false].join(' ')}>
                <Input
                    key={"prefix"+props.changedElements.content}
                    value={props.changedElements.archivenumberprefix ? props.changedElements.archivenumberprefix : ""}
                    elementType="select"
                    elementConfig={{options: options}}
                    changed={(event) => {
                        //props.setPrefix(event.target.value);
                        props.changeHandler({ archivenumberprefix: event.target.value });
                    }}
                />
            </td>
        </tr>
    );
}


class Metadata extends Component {

    structures = {}
    checkbox = {}    // internal structure to handle checkbox values

    defaults = {
        datefield: "",
        checkbox: "0",
        state: {
            updated: false,
            //mode: METADATA_MODE_TEXT,   // text for display, edit for editable
            content: METADATA_CONTENT_METADATA
        }
    }

    constructor(props) {
        super(props);
        this.languageHelper = new MetadataLanguage(this.props.config.languages, this.props.config.defaultLanguage);
        this.state = { ...this.defaults.state, ...this.initState(props) }
        this.structures = { ...this.initInternalStructures(props) };
        MetadataPermissionHelper.hasDeletePermission(props);
    }

    initState = (props) => {
        const state = {};

        state.id = props.id;
        state.type = props.type;
        state.tabs = props.tabs || [];
        state.lang = this.languageHelper.getInitialLang(props.appLang);
        state.elements = StructureMapping.getUsedElements(props.type, props.data, state.tabs);
        state.changed = {};
        state.fail = props.conditional;
        state.failMessage = props.message;
        state.mode = props.config.METADATA_MODE || METADATA_MODE_TEXT;

        state.metadataUtil = {};

        try {
            const Util = require(`../../../${process.env.REACT_APP_APPID}/util/metadataOnSaveUtil.js`).default;

            state.metadataUtil.metadataOnSaveUtil = new Util(state.elements);
        } catch (ex) {
            state.metadataUtil.metadataOnSaveUtil = null;
            console.log(ex);
        }

        return state;
    }

    initInternalStructures = (props) => {
        const structures = {};

        structures.tabs = StructureMapping.createTabStructure(props.type);
        structures.lang = StructureMapping.createLangStructure(props.type, props.config.languages);
        structures.checkbox = StructureMapping.createCheckboxStructure(props.type, props.data);
        structures.remove = StructureMapping.createRemoveStructure(props.type, props.data);

        return structures;
    }

    componentDidMount = () => {
        this.props.loadUsers();
    }

    getValue = (field) => {
        if (field && this.state.elements.hasOwnProperty(field)) {
            return this.state.elements[field];
        }
        return "";
    }

    toggleMetadata = () => {
        if (this.props.viewState === Panel.PANEL_VIEW_STATE_OPEN) {
            this.props.closed();
        } else {
            this.props.opened();
        }
    }

    //LAMTEST BEGIN
    saveStore = () => {
        //console.log("LAMTEST SAVE STORE")
        const { articleViewFields } = this.props.articleObjects;
        if (articleViewFields.id && articleViewFields.id == this.state.id && articleViewFields[`changedFields`]) {
            //20231017 this.props.updateMetadata("article", this.state.id, { ...articleViewFields[`changedFields`] });
            this.props.updateArticleObjects({ articleViewFields: {}, articleElements: {}, articleTabMetaLoading: true });
            LogsHelper.setEditLogsAction({
                id: this.state.id,
                updateArticleMetadata: this.props.updateArticleMetadata,
                metadata: { ...articleViewFields[`changedFields`] }
            });
        }
    }

    //LAMTEST END

    toggleMode = (mode) => {
        switch (mode) {
            case METADATA_MODE_TEXT:
                this.setState({ updated: false, mode: METADATA_MODE_EDIT });
                break;
            case METADATA_MODE_EDIT:
                let ok = true;
                if (this.state.updated) {
                    ok = this.updateData();
                } else {
                    //LAMTEST BEGIN
                    if (isVifogra()) this.saveStore();
                    //LAMTEST END
                }
                if (ok) {
                    if (this.props.config.METADATA_MODE === METADATA_MODE_EDIT) {
                        this.setState({ updated: false, mode: METADATA_MODE_EDIT });
                    } else {
                        this.setState({ updated: false, mode: METADATA_MODE_TEXT });
                    }
                }
                break;
            case METADATA_MODE_CANCEL:
                this.setState({ updated: false, mode: METADATA_MODE_TEXT });
                break;
            default:
                if (this.props.config.METADATA_MODE === METADATA_MODE_EDIT) {
                    this.setState({ updated: false, mode: METADATA_MODE_EDIT });
                } else {
                    this.setState({ updated: false, mode: METADATA_MODE_TEXT });
                }
                break;
        }
    }

    updateData = () => {
        let elements = {};
        let id = this.state.id;
        // NOTE: Metadata.OBJECT_TYPE_CLIP will not work - must be only OBJECT_TYPE_CLIP
        if (this.state.type === Metadata.OBJECT_TYPE_CLIP) {
            elements = { ...this.props.data, ...this.state.elements };
        } else {
            elements = { ...this.state.elements };
        }

        // remove entries which will not be saved
        this.structures.remove.forEach(item => {
            if (elements.hasOwnProperty(item)) {
                delete elements[item];
            }
        });

        if (this.state.type === OBJECT_TYPE_PM) {
            elements = this.checkMetadataUtil({ id: this.state.id, lang: this.state.lang, email: this.props.user.email, ...elements });
        } else {
            elements = this.checkMetadataUtil(elements);
        }

        // mandatory fail or not
        let fail = this.checkFieldConditions(elements);
        if (fail.length) {
            this.setState({ fail: fail, failMessage: "popup.title.mandatory.fail" });
            return false;
        }

        // validation fail or not
        fail = this.checkValidation(elements);
        if (fail.length) {
            this.setState({ fail: fail, failMessage: "popup.title.validation.fail" });
            return false;
        }

        // TODO: check with page ClipDetails.js
        let reloads = null;
        const components = this.checkReload(elements);
        if (components) {
            reloads = { components: components, id: this.props.projectId };
        }

        //LAMTEST BEGIN
        if (isVifogra()) {
            const { articleViewFields } = this.props.articleObjects;
            if (articleViewFields.id && articleViewFields.id == id && articleViewFields[`changedFields`]) {
                elements = { ...elements, ...articleViewFields[`changedFields`] };
                this.props.updateArticleObjects({ articleViewFields: {}, articleElements: {} });
            }
            this.props.updateArticleObjects({ articleTabMetaLoading: true });
            LogsHelper.setEditLogsAction({ id: this.state.id, updateArticleMetadata: this.props.updateArticleMetadata });
        }
        //LAMTEST END

        this.props.updateMetadata(this.state.type, id, elements, reloads);

        this.setState({ fail: [], failMessage: "" });
        return true;
    }

    checkFieldConditions = (elements) => {
        let fail = [];
        for (let key in elements) {
            let obj = StructureMapping.getField(this.state.type, key);
            let condition = StructureMapping.isCondition(obj);
            if (condition && !MetadataElementHelper.isConditionSuccess(condition, elements)) {
                elements[key] = "";
                if (this.structures.checkbox[key]) {
                    for (let value in this.structures.checkbox[key]) {
                        this.structures.checkbox[key][value] = false;
                    }
                }
            }

            if (StructureMapping.isMandatoryEdit(obj)) {
                if (!condition && !elements[key]) {
                    fail.push(key);
                } else {
                    if (condition && MetadataElementHelper.isConditionSuccess(condition, elements) && !elements[key]) {
                        fail.push(key);
                    }
                }
            }
        }
        return fail;
    }

    checkValidation = (elements) => {
        let fail = [];
        for (let key in elements) {
            let obj = StructureMapping.getField(this.state.type, key);
            let pattern = StructureMapping.getPattern(obj);
            if (pattern && elements[key] && !(elements[key] + "").match(pattern)) {
                fail.push(key);
            }
        }
        return fail;
    }

    checkReload = (elements) => {
        let reloads = [];
        for (let key in elements) {
            let obj = StructureMapping.getField(this.state.type, key);
            let reload = StructureMapping.isReload(obj);
            if (reload && reloads.indexOf(reload) === -1) {
                reloads.push(reload);
            }
        }
        return reloads;
    }

    checkMetadataUtil = (elements) => {
        let elms = { ...elements };

        for (let key in elms) {
            let obj = StructureMapping.getField(this.state.type, key);
            let util = StructureMapping.getUtil(obj);
            if (util && util.file && util.callback) {
                elms = this.state.metadataUtil[util.file][util.callback](elms);
            }
        }
        return elms;
    }

    showMandatoryMessage = () => {
        if (this.state.fail.length && this.state.failMessage) {
            Swal.fire({
                title: this.props.intl.formatMessage({ id: this.state.failMessage }),
                confirmButtonText: this.props.intl.formatMessage({ id: "common.ok" }),
                confirmButtonClass: [ButtonStyle.Button, ButtonStyle.Red].join(' '),
                buttonsStyling: false
            }).then((res) => {
                if (res.value) {
                    this.setState({ failMessage: "" });
                }
            });
        }
    }

    toggleLang = (lang) => {
        const newLang = this.languageHelper.switchLang(lang);
        this.setState({ lang: newLang });
    }

    toggleContent = (content) => {
        this.setState({ content: content, mode: this.props.config.METADATA_MODE || METADATA_MODE_TEXT });
    }

    changeHandler = (elements) => {
        const changedElements = {
            ...this.state.elements,
            ...elements
        };
        
        const changed = {
            ...this.state.changed,
            ...elements
        }

        this.setState({ elements: changedElements, updated: true, changed: changed });
        //LAMTEST BEGIN
        if (isVifogra()) {
            this.props.updateArticleObjects({ articleElements: { id: this.state.id, [`changedElements`]: changedElements } });
        }
        //LAMTEST END

        // callback in calling component (parent) 
        if (this.props.onChangeHandler) {
            //this.props.onChangeHandler(this.state.type, this.state.id, { ...elements });
        }
    }

    addMemberHandler = (input) => {
        if (input) {
            if (this.props.type === metadata.OBJECT_TYPE_UPLOADPROJECT) {
                this.props.addMemberToUploadProject(this.props.id, input);
            }
            else this.props.addMemberToProject(this.props.id, input);
        }

    }

    removeMemberHandler = (input) => {
        if (input) {
            if (this.props.type === metadata.OBJECT_TYPE_UPLOADPROJECT) {
                this.props.delMemberFromUploadProject(this.props.id, input);
            }
            else this.props.delMemberFromProject(this.props.id, input);
        }
    }

    createMetadata = () => {
        if (this.props.viewState !== Panel.PANEL_VIEW_STATE_OPEN) {
            return '';
        }

        let content = [];

        if (this.state.type === OBJECT_TYPE_CLIP && this.props.config.METADATA_PROJECT_OVERVIEW) {
            content.push(
                <tr key={"projects"}><th colSpan="2" className={classes.Section}><FormattedMessage id="metadata.tab.clipprojects" defaultMessage="Clip in Projects" /></th></tr>
            );

            content.push(
                <ProjectOverview
                    id={this.state.id}
                    originalObject={this.props.originalObject}
                    location={window.location.pathname} />
            );
        }

        for (let tab in this.state.tabs) {
            const tableElementsArray = this.createElements(this.state.tabs[tab]);
            let section = [];
            
            if (tableElementsArray.length > 0) {
                section.push(
                    <tr key={this.state.tabs[tab]}>
                        <th colSpan="2" className={classes.Section}>
                            <FormattedMessage id={this.state.tabs[tab]} />
                        </th>
                    </tr>
                );
                
                section = section.concat(tableElementsArray.map((element, i) => {
                    if(StructureMapping.isFunction(element.obj)) {
                        let func = StructureMapping.getFunction(element.obj);
                        console.log(func);
                        return (func && this[func] && this[func](element)) || "";
                    }
                    
                    return (
                        <tr key={element.id + i}>
                            <th className={[classes.Mandatory, (this.state.mode === 'edit' ? StructureMapping.isMandatoryEdit(element.obj) : "")].join(' ')}>
                                <FormattedMessage id={element.intl} defaultMessage={element.name} />
                                <Tooltip mode={this.state.mode} elm={element} />
                                <HelpWindow mode={this.state.mode} content={StructureMapping.hasHelp(element.obj)} />
                            </th>
                            <td className={[classes.Fail, (this.state.fail.length && (this.state.fail.indexOf(element.id) !== -1))].join(' ')}>
                                {element.field}
                                
                            </td>
                        </tr>
                    );
                }));
            }
            content = content.concat(section);
        }

        return content;
    }
    
    // TODO: remove -> PADB specific
    renderPrefix = (element) => {
        console.log(this.state);
        return (
            <ArchivenumberPrefix
                changedElements={this.state.changed}
                mode={this.state.mode} 
                element={element}
                changeHandler={this.changeHandler}/>
        );
    }

    createElements = (tab) => {
        let elementsArray = [];
        for (let key in this.state.elements) {
            //LAMTEST BEGIN
            let element = this.getElement(key);
            if (!StructureMapping.isParentonly(element.obj)
                || (StructureMapping.isParentonly(element.obj) && this.props.isParentPj)) {
                // if (this.showField(tab, key) && this.checkMediaType(key)) {
                if ((!isTranscoder1() && (this.showField(tab, key) && this.checkMediaType(key))) || isTranscoder1()) {
                    //let element = this.getElement(key);
                    if (element && !StructureMapping.isHidden(element.obj)) {
                        let condition = StructureMapping.isCondition(element.obj);
                        if (condition) {
                            if (MetadataElementHelper.isConditionSuccess(condition, this.state.elements)) {
                                elementsArray.push(element);
                            }
                        } else {
                            elementsArray.push(element);
                        }
                    }
                }
            }
            //LAMTEST END
        }

        return elementsArray.sort(StructureMapping.sortByOrder);
    }

    showField = (tab, field) => {
        if (!tab || !field) {
            return false;
        }

        if (!MetadataPermissionHelper.hasFieldPermission(this.props, field, 'see')) {
            return false;
        }

        if (!this.structures.lang[this.state.lang] || !this.structures.lang[this.state.lang].includes(field)) {
            return false;
        }

        if (this.structures.tabs[tab] && this.structures.tabs[tab].includes(field)) {
            return true;
        }

        return false;
    }

    checkMediaType = (key) => {
        if (this.props.mediaType != "video") {
            if (key === "duration_technical" || key === "eingebrannteuntertitel") {
                return false;
            }
        }

        if (this.props.mediaType != "pictures") {
            if (key === "aufloesung" || key === "format" || key === "bildformat") {
                return false;
            }
        }

        return true;
    }

    getElement = (key) => {
        const element = MetadataElementHelper.createElement(this.state.type, key, this.state.elements[key]);
        //console.log(element, key);
        if (this.showDisplayField(element, key)) {
            element.field = MetadataElementHelper.createDisplayField(element, this);
        } else {
            element.field = MetadataElementHelper.createEditField(element, this);
        }

        return element;
    }

    showDisplayField = (element, key) => {
        if (this.state.mode === METADATA_MODE_TEXT) { return true; }
        if (StructureMapping.isReadonly(element.obj)) return true;
        if (!MetadataPermissionHelper.hasPermission(this.props)) { return true; }
        if (!MetadataPermissionHelper.hasFieldPermission(this.props, key, 'edit')) { return true; }
        return false;
    }

    getExtraPanelButtons = () => {
        if (!this.props.extraPanels || this.props.extraPanels.indexOf(METADATA_CONTENT_SETTING) === -1) { return ""; }
        /*if (!this.props.data.hasOwnProperty("dlformats") && !this.props.data.hasOwnProperty("medialang")) { return ""; }*/
        if (!this.props.config.ROOM_SETTING) { return ""; }
        return (
            <Content
                content={this.state.content}
                click={this.toggleContent} />
        );
    }

    getContent = () => {
        let content = "";
        switch (this.state.content) {
            case METADATA_CONTENT_METADATA:
                content = this.createMetadata();
                break;
            case METADATA_CONTENT_SETTING:
                content = (
                    <>
                        <RoomSetting
                            room={this.props.data}
                            mode={this.state.mode} />
                    </>
                )
                break;
            default:
                content = this.createMetadata();
                break;
        }

        return (
            <IntlProvider
                key={this.state.lang}
                locale={this.state.lang}
                messages={this.props.config.languages[this.state.lang].messages}
            >

                <FlexColumn className={[classes.Container, "Metadata", this.state.type].join(' ')}>
                    <FlexRow className={[classes.Header].join(' ')}>
                        {/*<div><FontAwesomeIcon icon="folder" /></div>*/}
                        <div style={{ flex: 1 }}><FormattedMessage id={this.props.title} /></div>
                        {this.getExtraPanelButtons()}
                        {(this.props.id !== 0 && MetadataPermissionHelper.hasPermission(this.props)) ? <Icon mode={this.state.mode} click={() => this.toggleMode(this.state.mode)} cancel={() => this.toggleMode(METADATA_MODE_CANCEL)} /> : ""}
                        <Lang lang={this.state.lang} click={() => this.toggleLang(this.state.lang)} />
                    </FlexRow>
                    <FlexColumn className={classes.Content}>
                        <table>
                            <tbody>
                                {content}
                            </tbody>
                        </table>
                    </FlexColumn>
                </FlexColumn>

            </IntlProvider>
        );
    }

    render = () => {
        let content = '';
        let overlay = '';

        console.info(this.state.elements);
        
        console.log(this.props,this.state);

        if (this.props.viewState === Panel.PANEL_VIEW_STATE_OPEN) {
            content = this.getContent();
            if (this.props.loading) {
                overlay = (
                    <div className={classes.Overlay}>
                        <Spinner />
                    </div>
                );
            }
        }


        const attachedClasses = [classes.Metadata, classes[this.props.viewState], classes[this.state.mode], "relative"];

        return (
            <FlexColumn dir={(this.state.lang === 'ar' && "rtl") || "ltr"} className={attachedClasses.join(' ')}>
                {this.showMandatoryMessage()}
                {overlay}
                <Toggle open={this.props.open} toggle={this.toggleMetadata} />
                {content}
            </FlexColumn>
        );
    }

    componentWillUnmount = () => {
        //console.log("componentWillUnmount");
        if (this.state.updated) {
            this.showWantSave(this.props);
        }
    }

    async showWantSave(nextProps) {
        const { value: xy } = await Swal.fire({
            title: this.props.intl.formatMessage({ id: "popup.title.metadata.save.close" }),
            text: this.props.intl.formatMessage({ id: "popup.message.metadata.save.close" }),
            showCancelButton: true,
            cancelButtonText: this.props.intl.formatMessage({ id: "common.cancel" }),
            confirmButtonText: this.props.intl.formatMessage({ id: "common.ok" }),
            confirmButtonClass: [ButtonStyle.Button, ButtonStyle.Red].join(' '),
            cancelButtonClass: [ButtonStyle.Button, ButtonStyle.White].join(' '),
            buttonsStyling: false,
            allowOutsideClick: false
        });

        if (xy) {
            this.updateData();
        }

        this.props.resetMetadataConditional();
        const state = { ...this.state, ...this.defaults.state, ...this.initState(nextProps), lang: this.state.lang, fail: [], failMessage: "" }
        this.structures = { ...this.initInternalStructures(nextProps) };
        this.setState({ ...state });
    }

    componentWillReceiveProps(nextProps) {
        console.info("componentWillReceiveProps",nextProps.data.title,this.props.data.title,nextProps.loading,this.props.loading);
        // set only if different type or same type and different id (NAND)
        if (!((nextProps.type === this.props.type) && (nextProps.id + "" === this.props.id + ""))) {
            //console.log("ZERO", nextProps.type, this.props.type, nextProps.id, this.props.id);
            //ORIGINAL  if (this.state.updated) {
            //LAMTEST BEGIN
            const { articleViewFields } = this.props.articleObjects;
            if (this.state.updated || (articleViewFields.id && articleViewFields.id === this.props.id && articleViewFields[`changedFields`])) {
                if (isVifogra()) {
                    this.props.updateArticleObjects({ articleViewFields: { ...articleViewFields, [`articleWantSave`]: true } });
                }
                //LAMTEST END
                if (!isVifogra()) this.showWantSave(nextProps);
            } else {
                console.log("FIRST");
                this.props.resetMetadataConditional();
                const state = { ...this.state, ...this.defaults.state, ...this.initState(nextProps), lang: this.state.lang, fail: [], failMessage: "" }
                this.structures = { ...this.initInternalStructures(nextProps) };
                this.setState({ ...state });
            }
        } else if (nextProps.conditional.length && nextProps.message) {
            console.log("SECOND");
            const state = { ...this.state, fail: nextProps.conditional, failMessage: nextProps.message };
            this.setState({ ...state });
        } else if (nextProps.loading === false && this.props.loading === true) {
            console.log("THIRD");
            this.props.resetMetadataConditional();
            const state = { ...this.state, ...this.defaults.state, ...this.initState(nextProps), lang: this.state.lang, fail: [], failMessage: "", content: this.state.content }
            this.structures = { ...this.initInternalStructures(nextProps) };
            this.setState({ ...state });
        }
    }
}

const Toggle = (props) => {
    let attachedClasses = ["pointer"];

    if (props.open) {
        attachedClasses.push(classes.ToggleOpen);
        return (
            <FlexRow className={attachedClasses.join(' ')}>
                <Button
                    btnType="Transparent"
                    clicked={props.toggle}>
                    <FontAwesomeIcon icon="chevron-right" /> <FormattedMessage id="sidebar.minimize" /> <FormattedMessage id="sidebar.metadata" />
                </Button>
            </FlexRow>
        );
    }

    attachedClasses.push(classes.ToggleClosed);
    return (
        <FlexRow className={attachedClasses.join(' ')}>
            <Button
                btnType="Transparent"
                clicked={props.toggle}>
                <FontAwesomeIcon icon="chevron-left" />
            </Button>
        </FlexRow>
    );
}

const Icon = (props) => {
    if (props.mode === METADATA_MODE_TEXT) {
        return <div className="pointer" onClick={props.click}><span className={classes.Btn}><FontAwesomeIcon icon="pen" /></span></div>
    }
    return <div className="pointer" onClick={props.click}><span className={classes.Btn}><FontAwesomeIcon icon="save" /></span></div>;

    // TODO
    // if METADATA_MODE_CANCEL -> reset all changes in the local state ...

    /*
    return (<><div className="pointer" onClick={props.click}>
                <span className={classes.Lang}><FontAwesomeIcon icon="save" /></span>
            </div>
            <div className="pointer" onClick={props.cancel}>
                <span className={classes.Lang}><FontAwesomeIcon icon="window-close" /></span>
            </div></>);
    */
}

const Lang = (props) => {
    return <div className="pointer" onClick={props.click}><span className={classes.Btn}>{props.lang}</span></div>
}

const Content = (props) => {
    //return "";
    if (props.content === METADATA_CONTENT_METADATA) {
        return <div className="pointer" onClick={() => props.click(METADATA_CONTENT_SETTING)}><span className={classes.Btn}><FontAwesomeIcon icon="cog" /></span></div>
    }
    return <div className="pointer" onClick={() => props.click(METADATA_CONTENT_METADATA)}><span className={classes.Btn}><FontAwesomeIcon icon="folder" /></span></div>;
}

const mapStateToProps = (state, ownProps) => {
    //console.log(ownProps);
    const changedElements = state.metadata.changedElements[ownProps.type] && state.metadata.changedElements[ownProps.type][ownProps.id];

    return {
        rooms: state.rooms.rooms,
        projects: state.projects.projects,
        viewState: state.ui.metadataState,
        open: state.ui.metadataState === Panel.PANEL_VIEW_STATE_OPEN,
        appLang: state.ui.language,
        user: state.auth.user,
        users: state.user.users,
        config: state.ui.config,
        loading: state.metadata.loading,
        conditional: state.metadata.conditional,
        message: state.metadata.message,
        articleObjects: state.article.articleObjects,
        changedElements: changedElements
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        opened: () => dispatch(actions.metadataOpened()),
        closed: () => dispatch(actions.metadataClosed()),
        updateMetadata: (type, id, metadata, reloads) => dispatch(actions.updateMetadata(type, id, metadata, reloads)),
        updateArticleMetadata: (obj) => dispatch(actions.updateArticleMetadata(obj)),
        reloadComponent: (reloads, id) => dispatch(actions.reloadComponent(reloads, id)),
        addMemberToProject: (id, member) => dispatch(actions.addMemberToProject(id, member)),
        delMemberFromProject: (projectId, memberId) => dispatch(actions.delMemberFromProject(projectId, memberId)),
        addMemberToUploadProject: (id, member) => dispatch(actions.addMemberToUploadProject(id, member)),
        delMemberFromUploadProject: (projectId, memberId) => dispatch(actions.delMemberFromUploadProject(projectId, memberId)),
        loadUsers: () => dispatch(actions.userGetUsers()),
        resetMetadataConditional: () => dispatch(actions.resetMetadataConditional()),
        updateArticleObjects: (data) => dispatch(actions.updateArticleObjects(data))
        /*onChangeHandler: (type, id, elements) => {
            dispatch(actions.changeMetadata(type, id, elements))
        }*/
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(withRouter(Metadata)));
